'use strict';
require('../../css/password-reset.css');
angular.module('smartorg.r6.views.passwordReset', [
    'ngRoute',
    require('../../../../../components/password/app/js/plumbing/app.js')
]).config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/rr', {
            template: require('../../template/request-reset.html'),
            controller: 'RequestResetCtrl'
        });
        $routeProvider.when('/rp', {
            template: require('../../template/password-reset.html'),
            controller: 'ResetPasswordCtrl'
        });
        $routeProvider.when('/rp/:username/:key', {
            template: require('../../template/password-reset.html'),
            controller: 'ResetPasswordCtrl'
        });
    }]).controller('RequestResetCtrl', function ($scope, $location, config) {
    $scope.smartorg = config.smartorg;
    $scope.username = "";
    $scope.email = "";
    $scope.errorMessage = "";
    $scope.requestReset = function () {
        $scope.errorMessage = "";
        $scope.usernameWarning = !$scope.username;
        $scope.emailWarning = !$scope.email;
        if (!$scope.username || !$scope.email) {
            $scope.errorMessage = "Please enter username and email. ";
        }
        else {
            $scope.smartorg.requestResetPassword($scope.username, $scope.email).then(function (rs) {
                console.log(rs);
                if (rs) {
                    $scope.showConfirm = true;
                    $scope.autoDirect = true;
                    setTimeout(function () {
                        if ($scope.autoDirect) {
                            $location.path("/login");
                            $scope.$apply();
                        }
                    }, 10000);
                    $scope.errorMessage = "";
                }
                else {
                    $scope.errorMessage =
                        "We cannot match either username or email in our system.";
                }
                $scope.$apply();
            })["catch"](function (err) {
                console.error(err);
                $scope.errorMessage =
                    "We cannot match either username or email in our system.";
                $scope.$apply();
            });
        }
    };
    $scope.stopAutoRedirect = function () {
        $scope.autoDirect = false;
    };
    $scope.triggerEventByEnter = function (event) {
        if (event.which === 13) {
            $scope.requestReset();
        }
    };
}).controller('ResetPasswordCtrl', function ($scope, $routeParams, $window, $location, config) {
    $scope.verificationResult = false;
    $scope.smartorg = config.smartorg;
    $scope.username = $routeParams.username;
    $scope.verified = false;
    $scope.resetPassword = function (oldPassword, newPassword) {
        if ($routeParams.username && $routeParams.key && $scope.verificationResult) {
            $scope.smartorg.resetPasswordThroughEmail($routeParams.username, $routeParams.key, newPassword).then(function (rs) {
                if (rs) {
                    $scope.logingIn = true;
                    $scope.login($routeParams.username, newPassword);
                }
                else {
                    alert("Error, wrong key or key expired, please try again.");
                }
                $scope.$apply();
            })["catch"](function (err) {
                console.error(err);
                alert(err.message);
            });
        }
    };
    $scope.backToLogin = function () {
        $location.path("/login");
        $scope.$apply();
    };
    /**
     * Login to workbench.
     */
    $scope.login = function (username, password) {
        $scope.smartorg.authenticate({
            'username': username,
            'password': password
        }).then(function (userInfo) {
            // console.log(userInfo);
            $scope.smartorg.protocols.credentials.isAdmin =
                userInfo.is_admin;
            setTimeout(function () {
                $scope.loggedIn();
            }, 3);
        })["catch"](function (err) {
            alert("Unexpected error. Please contact administrator.");
            console.error(err);
        });
    };
    /**
     * What to do after successfully login.
     */
    $scope.loggedIn = function () {
        // Should check if needs to go into first page.
        $location.path("/firstpage");
        $scope.$apply();
    };
    $scope.finishVerification = function () {
        $scope.verified = true;
    };
    $scope.verifyUserAndKey = function () {
        $scope.verified = false;
        if ($routeParams.username && $routeParams.key) {
            $scope.smartorg.checkResetPasswordKey($routeParams.username, $routeParams.key).then(function (rs) {
                $scope.verificationResult = rs;
                $scope.finishVerification();
                $scope.$apply();
            })["catch"](function (err) {
                console.error(err);
                $scope.finishVerification();
                $window.location.href = "404.html";
            });
        }
    };
    $scope.verifyUserAndKey();
});
module.exports = 'smartorg.r6.views.passwordReset';
//# sourceMappingURL=password-reset.js.map


// WEBPACK FOOTER //
// ./app/views/password-reset/app/js/plumbing/password-reset.js